export default __webpack_public_path__ + "591c72d0d3354cb65f3bc2ec4ed327a1.svg";